document.addEventListener('DOMContentLoaded', function() {
  let isFiltering = false;
  let lastConstraint = null;
  
  // Intercepta requisições AJAX do tema
  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;
  
  XMLHttpRequest.prototype.open = function(method, url) {
    this._url = url;
    return originalOpen.apply(this, arguments);
  };
  
  XMLHttpRequest.prototype.send = function() {
    const url = this._url;
    
    if (url && url.includes('/collections/')) {
      this.addEventListener('load', function() {
        setTimeout(() => {
          applyCustomFilter();
          removeDuplicates();
        }, 300);
      });
    }
    return originalSend.apply(this, arguments);
  };
  
  // Remove produtos duplicados
  function removeDuplicates() {
    const productContainers = document.querySelectorAll('.js_size_prod.js_loadmore');
    const seen = new Set();
    
    productContainers.forEach(container => {
      const link = container.querySelector('a[href*="/products/"]');
      if (!link) return;
      
      const productHandle = link.href.split('/products/')[1].split('?')[0];
      
      if (seen.has(productHandle)) {
        container.remove();
      } else {
        seen.add(productHandle);
      }
    });
  }
  
  // Aplica filtro no carregamento inicial
  setTimeout(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('constraint')) {
      applyCustomFilter();
    }
  }, 500);
  
  async function applyCustomFilter() {
    if (isFiltering) return;
    
    isFiltering = true;
    
    const urlParams = new URLSearchParams(window.location.search);
    const constraint = urlParams.get('constraint');
    
    if (constraint !== lastConstraint) {
      lastConstraint = constraint;
    }
    
    const productContainers = document.querySelectorAll('.js_size_prod.js_loadmore');
    
    if (productContainers.length === 0) {
      isFiltering = false;
      return;
    }
    
    if (!constraint) {
      productContainers.forEach(container => {
        container.style.display = '';
      });
      isFiltering = false;
      return;
    }
    
    const selectedSize = constraint.split(/[\s+]+/)[0].trim().toUpperCase();
    const checkPromises = [];
    
    for (const container of productContainers) {
      const productLink = container.querySelector('a[href*="/products/"]');
      if (!productLink) continue;
      
      const productHandle = productLink.href.split('/products/')[1].split('?')[0];
      
      const checkPromise = fetch(`/products/${productHandle}.js`)
        .then(res => res.json())
        .then(product => {
          const hasAvailableSize = product.variants.some(variant => {
            if (!variant.available) return false;
            const variantSize = (variant.option1 || variant.option2 || variant.option3 || '').toUpperCase();
            return variantSize === selectedSize;
          });
          
          return { container, hasAvailableSize };
        })
        .catch(() => {
          return { container, hasAvailableSize: true };
        });
      
      checkPromises.push(checkPromise);
    }
    
    const results = await Promise.all(checkPromises);
    
    results.forEach(({ container, hasAvailableSize }) => {
      container.style.display = hasAvailableSize ? '' : 'none';
    });
    
    isFiltering = false;
  }
});